import React, { Component } from "react";
import { connect } from "react-redux";

import NewDashboard from "./NewDashboard";
import { checkIfUserHasMetadata } from "app/NativeActions";
class Dashboard extends Component {
  render() {
    return <NewDashboard />;
  }
}

const mapStateToProps = ({ auth, native, settings }) => {
  const { token, user } = auth;
  const { device, window_height, isMobile } = native;
  const { colors, dark_mode } = settings;

  return {
    token,
    user,
    device,
    isMobile,
    window_height,
    colors,
    dark_mode
  };
};

export default connect(mapStateToProps, {})(Dashboard);
